import { Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Ribbon from "./Ribbon";
import LotTable from "./LotTable";
import ConsumptionDetailsCards from "./ConsumptionDetailsCards";
import axios from "axios";
import { appUrl } from "../../../../../../../utils/config";
import ChatBox from "./commentSectionRMPM";
import ProductDetailsLoader from "../ProductDetailsLoader";

export default function ViewBatchDetails(props) {
  const {
    selectedDeliveryBatchID,
    targetQuantity,
    batchDetails,
    showRMPMDetails,
    row,
    dashboardViewConsumption = false,
    poDashboardBatch = false,
    batchRowData,
    cmoBatchNumber,
    onDataRefresh,
  } = props;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [plantAndStorageData, setPlantAndStorageData] = useState(null);
  const [responseData, setResponseData] = useState({});

  // Fetch component allocation data based on batchDetails
  useEffect(() => {
    if (batchDetails && selectedDeliveryBatchID) {
      setLoading(true);

      let url = "";
      if (
        row?.batchDetails?.bomConsumptionAddedIndicator ||
        batchDetails?.bomConsumptionAddedIndicator
      ) {
        // Get batchSize from batchDetails or row.batchDetails
        const batchSize =
          batchDetails?.batchSize ||
          row?.batchDetails?.batchSize ||
          batchRowData?.batchSize;
        url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNewDirect/${selectedDeliveryBatchID}/${batchSize}`;
      } else {
        url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${
          localStorage.collabType
        }/${localStorage.roleName}/fetchComponentAllocationForPOLineNewDirect/${
          row?.scheduleLineDetails?.schrockenSLID || batchDetails?.schrockenSLID
        }`;
      }

      axios
        .get(url)
        .then((res) => {
          if (res.data.status) {
            if (
              batchDetails?.bomConsumptionAddedIndicator ||
              row?.batchDetails?.bomConsumptionAddedIndicator
            ) {
              // For fetchComponentAllocationPlannedAndActualNew API
              const responseData = res?.data?.data || [];
              setTableData(responseData);
              setError(false);
              setResponseData(res?.data || {});
            } else {
              // For fetchComponentAllocationForPOLineNew API
              const responseData =
                res.data.data?.componentAllocationDataList || [];
              setTableData(responseData);
              setResponseData(res?.data || {});
              setError(false);
            }
          } else {
            console.error("API returned false status:", res.data);
            setError(true);
            setTableData([]);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          console.error("Error details:", {
            message: err.message,
            response: err.response?.data,
            status: err.response?.status,
          });
          setError(true);
          setTableData([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [batchDetails, selectedDeliveryBatchID, row, batchRowData]);

  // Fetch all receiving plant IDs and storage location IDs
  useEffect(() => {
    const fetchReceivingPlantAndStorageLocationIDs = () => {
      const vendorMosymphonyID =
        row?.scheduleLineDetails?.vendorMosymphonyID ||
        batchDetails?.vendorMosymphonyID;

      if (vendorMosymphonyID) {
        axios
          .get(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReceivingPlantIDsAndStorageLocationIDsDirect/${vendorMosymphonyID}`
          )
          .then((res) => {
            if (res.data.status && res.data.vendorOrgLevelData) {
              setPlantAndStorageData(res.data.vendorOrgLevelData);
            }
          })
          .catch((err) => {
            console.error(
              "Error fetching receiving plant IDs and storage location IDs:",
              err
            );
          });
      }
    };

    // Call the API when component mounts or dependencies change
    fetchReceivingPlantAndStorageLocationIDs();
  }, [batchDetails, row]);

  let consumptionCards = null;

  if (poDashboardBatch) {
    consumptionCards = false;
  } else if (dashboardViewConsumption) {
    consumptionCards = false;
  } else {
    consumptionCards = true;
  }

  return (
    <React.Fragment>
      {batchDetails && (
        <Grid container justifyContent="center">
          <Grid item xs={11} sm={11} md={11} style={{ marginTop: "20px" }}>
            {!consumptionCards && (
              <Ribbon
                batchDetails={batchDetails}
                targetQuantity={targetQuantity}
                showRMPMDetails={showRMPMDetails}
                row={row}
                plantAndStorageData={plantAndStorageData}
                poDashboardBatch={poDashboardBatch}
              />
            )}

            {consumptionCards && (
              <ProductDetailsLoader
                collabrixProductID={batchDetails.collabrixProductID}
                poNumber={batchDetails?.scheduleAgreementNumber}
                materialPlantID={batchDetails?.vendorPlant}
                materialStorageLocationID={batchDetails?.storageLocation}
                batchNumber={
                  batchRowData?.vendorBatchNumber ||
                  batchDetails?.vendorBatchNumber
                }
                vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
                vendorPlantID={batchDetails?.vendorPlant}
                sponsorStorageLocation={batchDetails?.storageLocation}
              />
            )}

            {!consumptionCards && (
              <LotTable
                apiData={tableData}
                loading={loading}
                error={error}
                batchDetails={{
                  ...batchDetails,
                  bomConsumptionAddedIndicator:
                    batchDetails?.bomConsumptionAddedIndicator ||
                    row?.batchDetails?.bomConsumptionAddedIndicator,
                }}
              />
            )}

            {consumptionCards && (
              <ConsumptionDetailsCards
                batchDetails={batchDetails}
                loading={loading}
                cmoBatchNumber={cmoBatchNumber}
                onDataRefresh={onDataRefresh}
              />
            )}

            {responseData?.consumptionDataReqdForIBDGRN &&
              typeof responseData?.allocationOwnedBySponsor === "boolean" && (
                <div
                  style={{
                    marginTop: "1rem",
                    padding: "0.75rem 1rem",
                    backgroundColor: "#fff",
                    border: "1px solid #0b0b0bff",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                  }}
                >
                  <Typography variant="body2">
                    {responseData?.allocationOwnedBySponsor
                      ? `Note - Allocation is owned by ${
                          batchDetails?.brandOwnerName ||
                          row?.batchDetails?.brandOwnerName ||
                          batchRowData?.brandOwnerName
                            ? batchDetails?.brandOwnerName ||
                              row?.batchDetails?.brandOwnerName ||
                              batchRowData?.brandOwnerName
                            : "BMS"
                        }`
                      : `Note - Allocation is not owned by ${
                          batchDetails?.brandOwnerName ||
                          row?.batchDetails?.brandOwnerName ||
                          batchRowData?.brandOwnerName
                            ? batchDetails?.brandOwnerName ||
                              row?.batchDetails?.brandOwnerName ||
                              batchRowData?.brandOwnerName
                            : "BMS"
                        }`}
                  </Typography>
                </div>
              )}
            {typeof responseData?.consumptionDataReqdForIBDGRN === "boolean" &&
              responseData?.consumptionDataReqdForIBDGRN === false && (
                <div
                  style={{
                    marginTop: "1rem",
                    padding: "0.75rem 1rem",
                    backgroundColor: "#fff",
                    border: "1px solid #0b0b0bff",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                  }}
                >
                  <Typography variant="body2">
                    {!responseData?.consumptionDataReqdForIBDGRN &&
                      `Note - Consumption Information is not required for IBD/GRN`}
                  </Typography>
                </div>
              )}
          </Grid>
        </Grid>
      )}

      {/* ChatBox - Show only if vendorBatchNumber exists */}
      {batchDetails?.vendorBatchNumber && (
        <ChatBox
          batchDetails={batchDetails}
          //vendorMosymphonyID={POData.vendorMosymphonyID}
        />
      )}
    </React.Fragment>
  );
}
